import { FunctionComponent, ReactNode } from "react";
import MathJax from "../../components/MathJax";
import classNames from "classnames";
import styles from "./Scores.module.css";
import Spinner from "../../components/Spinner";
import MathUtils from "../../utils/MathUtils";

export type THeaderCellProps = {
  label: string;
  value?: number | string;
  label2?: string;
  classname?: string;
};

export type TValueCellProps = {
  value?: number | string;
  decimals?: number;
  unit?: string;
  classname?: string;
  valueSuffix?: ReactNode;
  thirdCell?: ReactNode;
};

const getRoundedValue = (value: number, decimals?: number) =>
  String(MathUtils.round(value, decimals));

export const ScoreCell: FunctionComponent<{
  children: ReactNode;
  gray?: boolean;
  className?: string;
}> = (props) => (
  <td
    className={classNames(
      styles.cell,
      { [styles.gray]: props.gray },
      props.className
    )}
  >
    {props.children}
  </td>
);

export const ScoreHeaderCell = (props: THeaderCellProps) => (
  <ScoreCell className={props.classname}>
    {<MathJax tex={props.label} />}
    {props.label2 && <MathJax tex={props.label2} />}
  </ScoreCell>
);

export const ScoreValueCell: FunctionComponent<TValueCellProps> = (props) => {
  const valueToDisplay =
    typeof props.value === "number"
      ? getRoundedValue(props.value, props.decimals)
      : props.value;

  return (
    <ScoreCell className={props.classname}>
      {props.value !== undefined ? (
        <MathJax tex={`${valueToDisplay}${props.unit ?? ""}`} />
      ) : (
        <Spinner />
      )}
      {props.valueSuffix}
    </ScoreCell>
  );
};

const ScoreRow: FunctionComponent<THeaderCellProps & TValueCellProps> = (
  props
) => (
  <tr key={props.label}>
    <ScoreHeaderCell label={props.label} label2={props.label2} />
    <ScoreValueCell
      value={props.value}
      unit={props.unit}
      decimals={props.decimals}
      valueSuffix={props.valueSuffix}
    />
    {props.thirdCell && (
      <ScoreCell className={classNames(props.classname, styles.thirdCell)}>
        {props.thirdCell}
      </ScoreCell>
    )}
  </tr>
);

export default ScoreRow;
